// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import Int32LookupRequestViewModel from '../../../../viewModel/resource/Int32LookupRequestViewModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import Int32LookupRequestListResultViewModel from '../../../../viewModel/resource/Int32LookupRequestListResultViewModel';
import Int32LookupRequestListResultDTO from '../../dto/resource/Int32LookupRequestListResultDTO';

export default abstract class Int32LookupRequestListResultModel extends BaseModel<Int32LookupRequestListResultDTO> {
  /**
  */
  get items() { return this.getArrayModels(() => this.dto.items, Int32LookupRequestViewModel)!; }
  set items(value) { this.setArrayModels(() => this.dto.items, value); }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
  }
}
